import React, { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import DoctorCardIC from "./DoctorCardIC/DoctorCardIC";
import FindDoctorSearchIC from "./FindDoctorSearchIC/FindDoctorSearchIC";
import "./InstantConsultation.css";

const InstantConsultation = () => {
  const [searchParams] = useSearchParams();
  const [filteredDoctors, setFilteredDoctors] = useState([]);
  const [isSearched, setIsSearched] = useState(false);

  useEffect(() => {
    fetch("https://api.npoint.io/9a5543d36f1460da2f63")
      .then((res) => res.json())
      .then((data) => {
        if (searchParams.get("speciality")) {
          const filtered = data.filter(
            (doctor) =>
              doctor.speciality.toLowerCase() ===
              searchParams.get("speciality").toLowerCase()
          );
          setFilteredDoctors(filtered);
          setIsSearched(true);
        } else {
          setFilteredDoctors([]);
          setIsSearched(false);
        }
      })
      .catch((err) => console.log(err));
  }, [searchParams]);

  return (
    <div className="searchpage-container">
      <FindDoctorSearchIC />
      <div className="search-results-container">
        {isSearched && (
          <>
            <h2>{filteredDoctors.length} doctors available for instant consult</h2>
            <h3>Connect immediately with verified specialists</h3>
            {filteredDoctors.length > 0 ? (
              <div className="doctors-grid">
                {filteredDoctors.map((doctor) => (
                  <DoctorCardIC {...doctor} key={doctor.name} />
                ))}
              </div>
            ) : (
              <p>No doctors found for this specialty.</p>
            )}
          </>
        )}
      </div>
    </div>
  );
};

export default InstantConsultation;
